import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  grid: {
    overflow: 'hidden',
  },
  textOverflowTooltip: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

export default useStyles;
